import axios from "@/lib/axios"

export default async(name:string)=>{
    return await axios.instance.get(`/user/project/${encodeURI(name)}`).then(response=>{
        return response.data.data
    }).catch(e=>{
        return null
    })
}